// extracted by mini-css-extract-plugin
module.exports = {"message":"_7874687","button":"_8898134"};